let language = {
    // 产品查询失败
    "CATALOG-SEARCH-LOADING-ISSUE-TITLE":"Products Loading Issue",
    "CATALOG-SEARCH-LOADING-ISSUE-CONTENT":"An issue occurred while loading products. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    "CATALOG-SEARCH-CURRENCY-ISSUE-CONTENT":"Your preferred currency type is not currently supported.Please click the \"{{updateCurrencyBtn}}\" button at the top of the page to update the currency. ",
    A102B3000601: "The current currency: {{currentCurrency}}, supported currency types on the {{appName}} platform: {{supportCurrencies}}",
    A102B300310: "The currency {{currentCurrency}} does not exist in the system."
};

export { language }